import * as React from "react";
const SvgSectionPlane = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#1952b3", fillRule: "evenodd", d: "M18 6H6v12h12zM4 4v16h16V4z", clipRule: "evenodd" }), /* @__PURE__ */ React.createElement("path", { fill: "#232729", d: "M8 8h8v8H8z" }));
export default SvgSectionPlane;
